const COIN_CONTRACT_ADDRESS = "0x0000000000000000000000000000000000000001";

export const isCoin = (currency: { contractAddress: string }) => {
  if (currency.contractAddress === COIN_CONTRACT_ADDRESS) {
    return true;
  }
  return false;
};
